import { getVariantPrice } from './index';

const WEEKDAYS = [
  'Domenica',
  'Lunedì',
  'Martedì',
  'Mercoledì',
  'Giovedì',
  'Venerdì',
  'Sabato',
];

const pad = (n) => String(n).padStart(2, '0');

// Data locale YYYY-MM-DD (non UTC: a mezzanotte toISOString sbaglia giorno)
export const toLocalIsoDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const isRegistrationOpen = (event) =>
  event?.iscrizioniAperte === true || event?.iscrizioniAperte === 'true';

const eventHappensOn = (event, day, weekday) => {
  const start = event.Data;
  const end = event.Date_end;
  if (event.Recurring) {
    return (
      event.Recurring === weekday &&
      (!start || start <= day) &&
      (!end || end >= day)
    );
  }
  return Boolean(start) && start <= day && (end || start) >= day;
};

const variantHappensOn = (variant, day) => {
  if (!variant.Data_inizio) return false;
  const start = toLocalIsoDate(new Date(variant.Data_inizio));
  const end = variant.Data_Fine
    ? toLocalIsoDate(new Date(variant.Data_Fine))
    : start;
  return start <= day && end >= day;
};

const timeOf = (isoDateTime) => {
  const d = new Date(isoDateTime);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * Eventi gratuiti di oggi con iscrizioni aperte a cui iscriversi insieme alla
 * tessera. Un evento con varianti diventa una scelta per ogni variante
 * gratuita di oggi. Ritorna [{ key, event, variant, label, time }].
 */
export const getFreeEventOptionsForDay = (events = [], now = new Date()) => {
  const day = toLocalIsoDate(now);
  const weekday = WEEKDAYS[now.getDay()];
  const options = [];

  events.filter(isRegistrationOpen).forEach((event) => {
    const varianti = event.Varianti || [];
    if (varianti.length === 0) {
      if (event.is_free && eventHappensOn(event, day, weekday)) {
        options.push({
          key: event.documentId,
          event,
          variant: null,
          label: event.Nome,
          time: event.Ora_inizio ? event.Ora_inizio.slice(0, 5) : '',
        });
      }
      return;
    }
    varianti
      .filter(
        (variant) =>
          getVariantPrice(variant, event) === 0 &&
          variantHappensOn(variant, day)
      )
      .forEach((variant) => {
        options.push({
          key: variant.documentId,
          event,
          variant,
          label: `${event.Nome} - ${variant.Nome}`,
          time: timeOf(variant.Data_inizio),
        });
      });
  });

  return options.sort((a, b) => (a.time || '').localeCompare(b.time || ''));
};
